<div class="fullcontainer">
  <app-workshop-nav></app-workshop-nav>
  <div>
    <br />
    <div class='titleContainer'>
      <h2 class='header'>Defect Severities</h2>
    </div>
    <br />


    <div class="row content-block">
      <div class="col">
        <table class='table table-bordered table-hover' >
          <thead class='thead-light'>
            <tr>
              <th>Severity Level</th>
              <th>Name</th>
              <th>Is VOR?</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            @for (severity of this.severities; track severity) {
              <tr>
                <td>{{severity.severity}}</td>
                <td>{{severity.notes}}</td>
                @if (severity.isVor) {
                  <td>Failure is Auto-VOR</td>
                }
                @if (!severity.isVor) {
                  <td>Failure is not Auto-VOR</td>
                }
                <td>
                  @if (severity.severity === 1) {
                    <button class='btn btn-light disabled' [class.disabled]='this.disableButtons'><i class="far fa-caret-square-up"></i></button>
                  }
                  @if (severity.severity > 1) {
                    <button class='btn btn-info' [class.disabled]='this.disableButtons' (click)='this.moveUp(severity.severity)'><i class="far fa-caret-square-up"></i></button>
                  }
                  @if (severity.severity === this.severities.length) {
                    <button class='btn btn-light disabled' [class.disabled]='this.disableButtons'><i class="far fa-caret-square-down"></i></button>
                  }
                  @if (severity.severity < this.severities.length) {
                    <button class='btn btn-info' [class.disabled]='this.disableButtons' (click)='this.moveDown(severity.severity)'><i class="far fa-caret-square-down"></i></button>
                  }
                </td>
              </tr>
            }

            @if (!addRow) {
              <tr>
                <td colspan='4'>
                  <button class='btn btn-secondary' [class.disabled]='this.disableButtons' (click)='addNewRow()'><i class="fas fa-plus"></i> New</button>
                </td>
              </tr>
            }

            @if (addRow) {
              <tr>
                <td>{{this.newRow.severity}}</td>
                <td>
                  <label>Name</label>
                  <input type='text' [(ngModel)]='this.newRow.notes' class='form-control' [class.is-valid]='this.newRow.notes !== ""' [class.is-invalid]='this.newRow.notes === ""'/>
                </td>
                <td>
                  <label>Is VOR?</label>
                  <select
                    (change)='changeDropdown($event)'
                    class='form-control'
                    >
                    <option [value]='0' [selected]='this.newRow.isVor === false'>No</option>
                    <option [value]='1' [selected]='this.newRow.isVor === true'>Yes</option>
                  </select>
                </td>
                <td>
                  <button class='btn btn-success' [class.disabled]='this.disableButtons' (click)='this.save()'>Save</button>
                  <button class='btn btn-warning' [class.disabled]='this.disableButtons' (click)='cancel()'>Cancel</button>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
